import * as d3 from 'd3'

export default {

  methods: {
    pie_Link(selection, d, idx) {
      
      if (d.filter == undefined || d.filter == null || d.filter == '' ) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', ()=> {
        d3.select(`#LEGEND_ITEM_${idx}_${this.localId}`).transition().duration(50).style('opacity', .4)
        d3.select(`#PIE_${idx}_${this.localId}`).transition().duration(50).attr('opacity', .4)
      })
      .on('mouseout', ()=> {
        d3.select(`#LEGEND_ITEM_${idx}_${this.localId}`).transition().duration(50).style('opacity', 1)
        d3.select(`#PIE_${idx}_${this.localId}`).transition().duration(50).attr('opacity', this.colorSet[idx].opacity)
      })
      .on('click', () => {
        this.link_Action(this.filters[d.filter], d.json) 
      })
    },
    
    event_Link(selection, d) {
      
      if (d.filter == undefined || d.filter == null || d.filter == '' ) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        this.link_Action(this.filters[d.filter], d.json) 
      })
    },

    link_Action(filter_, json_) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: this.dataset[this.keys[d]]}
      })
      let filterString_ = filter_ || ''
      let requestText = (json_ && json_ != '') ? json_ : 'request'
      console.log(requestText, dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(requestText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },

  } 
}